import * as React from "react";
import { inject,observer } from 'mobx-react';
import ModelStore from 'src/stores/ModelStore';
import IModelFormat from "src/interfaces/IModelFormat";


interface IProps {
  modelStore?: ModelStore;
}
@inject("modelStore")
@observer
export default class Refinements extends React.Component<IProps,{}> {

  constructor (props?: any , state?:any){
      super (props, state);
  }  

  public render() {
   
      return (
        <div className="service-list refinements">
          <h2>Veredelung auswählen (optional)</h2>
          <ul>
            { this._renderSubItems()}  
          </ul>  
        </div>
    );

    
  }

  private _selectModel (model:IModelFormat){
    const modelStore = this.props.modelStore as ModelStore;
    modelStore.setSelectedSubMenuItem(model);
    
  }

  private _renderSubItems():React.ReactNode[]{
    const modelStore = this.props.modelStore;
    const items:any[] = [];
    modelStore!.subMenu!.map( 
      (model: IModelFormat , index: number )=>{
      
      items.push(<li key={'item-' + index } onClick={ this._selectModel.bind(this, model) } className="selectable"><span className={"check-box" + (model.selected ? " checked":"")} /><span className="label">{ model.title }</span></li>)
   
    }); 
    

    return items;
  }

}


// WEBPACK FOOTER //
// ./src/components/Refinements.tsx